import React, { useEffect, useRef, useState } from "react";
import { DateRangePicker as BootstrapDateRangePicker } from "react-bootstrap-daterangepicker";

const CustomDateRangePicker = ({ children, ...props }) => {
    const [dropDirection, setDropDirection] = useState("down"); // Default to down
    const inputRef = useRef(null);
    const contentRef = useRef(null); // Reference for the `.content` container
    const datePickerRef = useRef(null);

    useEffect(() => {
        const adjustDropDirection = () => {
            if (inputRef.current && contentRef.current) {
                const rect = inputRef.current.getBoundingClientRect();
                const spaceBelow = contentRef.current.clientHeight - rect.bottom;
                const spaceAbove = rect.top;

                // Adjust drop direction dynamically
                setDropDirection(spaceBelow < 350 && spaceAbove > spaceBelow && spaceAbove > 350 ? "up" : "down");
            }
            if(datePickerRef.current && inputRef.current) {
                // Because we are using .content container - we need to update the view manually on scroll 
                datePickerRef.current.container.css('top', `${inputRef.current.getBoundingClientRect().bottom}px`);
            }
        };

        // Find the `.content` element dynamically in the React lifecycle
        contentRef.current = document.querySelector('.content');

        if (contentRef.current) {
            contentRef.current.addEventListener("scroll", adjustDropDirection);
        }
        window.addEventListener("resize", adjustDropDirection);

        // Run once on mount
        adjustDropDirection();

        return () => {
            if (contentRef.current) {
                contentRef.current.removeEventListener("scroll", adjustDropDirection);
            }
            window.removeEventListener("resize", adjustDropDirection);
        };
    }, []);

    const handleOnShow = (event, picker) => {
        // Save the reference to the picker - used to update the elem top position
        datePickerRef.current = picker;
    }

    return (
        <BootstrapDateRangePicker {...props} drops={dropDirection} onShow={handleOnShow}
            onCancel={() => {
                if(props.canClear && inputRef.current) {
                    // Clear the input value when the user cancels the date range picker
                    inputRef.current.value = "";
                }
                if(props.onCancel) {
                    props.onCancel();
                }
            }}>
            {React.cloneElement(children, { ref: inputRef })}
        </BootstrapDateRangePicker>
    );
};

export default CustomDateRangePicker;